import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import HlcFooter from '../components/HlcFooter';
import { getProductImage } from '../utils/getProductImage';
import { API_BASE_URL } from '../config/apiConfig';

export default function ProductByApplication() {
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const selectedSubcategory = state?.subcategory || "";
  const subcategoryDescription = state?.subcategoryDescription || "";

  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [filters, setFilters] = useState({
    main: '',
    app: '',
    watt: ''
  });

    const ProductImage = ({ product }) => (
      <div className="product-image">
        <img
          src={getProductImage(product)}
          alt="product"
          style={{ width: '100%', height: '240px', objectFit: 'contain', background: '#f5f5f5' }}
        />
      </div>
    );

  // Fetch products from adminhlc-api (MySQL) — Step 5 of the Firebase->PHP migration
  // ROLLBACK: original Firebase implementation:
  // useEffect(() => {
  //   const productsRef = dbRef(db, 'products');
  //   const unsubscribe = onValue(productsRef, (snapshot) => {
  //     const data = snapshot.val();
  //     const parsed = data
  //       ? Object.keys(data).map((key) => ({ id: key, ...data[key] }))
  //       : [];
  //     setProducts(parsed);
  //     const filtered = parsed.filter(
  //       (p) => p.applicationSubType === selectedSubcategory
  //     );
  //     setFilteredProducts(filtered);
  //   });
  //   return () => unsubscribe();
  // }, [selectedSubcategory]);
  useEffect(() => {
    let cancelled = false;

    fetch(`${API_BASE_URL}/api/public/products/list.php`)
      .then((res) => res.json())
      .then((data) => {
        if (cancelled) return;
        const parsed = Array.isArray(data) ? data : [];
        setProducts(parsed);

        // Filter by applicationSubType matching selectedSubcategory
        const filtered = parsed.filter(
          (p) => p.applicationSubType === selectedSubcategory
        );
        setFilteredProducts(filtered);
      })
      .catch((err) => {
        console.error("Failed to fetch products:", err);
        if (!cancelled) {
          setProducts([]);
          setFilteredProducts([]);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [selectedSubcategory]);

  // Fetch categories from adminhlc-api (MySQL) — Step 4 of the Firebase->PHP migration
  useEffect(() => {
    let cancelled = false;

    fetch(`${API_BASE_URL}/api/public/categories/list.php`)
      .then((res) => res.json())
      .then((data) => {
        if (cancelled) return;
        setCategories(Array.isArray(data) ? data : []);
      })
      .catch((err) => {
        console.error("Failed to fetch categories:", err);
        if (!cancelled) setCategories([]);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const applicationSubTypes = {
    "Residential Lighting": ["Living Rooms", "Bedrooms", "Kitchens", "Outdoor & Balconies"],
    "Commercial Lighting": ["Office Lighting", "Retail & Showroom Lighting", "Hospitality Lighting", "Educational Institutions"],
    "Industrial Lighting": ["Factories Lighting", "Warehouse Lighting", "Workshops Lighting"],
    "Outdoor & Landscape": [],
    "Retail & Showrooms": [],
  };

  // Handle filter changes
  const handleFilterChange = (filterType, value) => {
    setFilters(prev => ({ ...prev, [filterType]: value }));
  };

  const applyFilters = () => {
    let temp = products.filter(
      (p) => p.applicationSubType === selectedSubcategory
    );

    // Main category filter
    if (filters.main) {
      temp = temp.filter(p => p.category?.toLowerCase() === filters.main.toLowerCase());
    }

    // Application filter
    if (filters.app) {
      temp = temp.filter(p => p.applicationType?.toLowerCase() === filters.app.toLowerCase());
    }

    // Wattage filter
    if (filters.watt) {
      temp = temp.filter(p => {
        if (!p.wattColourModel) return false;
        const watt = parseFloat(p.wattColourModel.replace(/[^\d.]/g, ''));
        switch (filters.watt) {
          case '5-9':
            return watt >= 5 && watt <= 9;
          case '10-18':
            return watt >= 10 && watt <= 18;
          case '20-30':
            return watt >= 20 && watt <= 30;
          case '50+':
            return watt >= 50;
          default:
            return true;
        }
      });
    }

    setFilteredProducts(temp);
  };

  const clearFilters = () => {
    setFilters({ main: '', app: '', watt: '' });
    const filtered = products.filter(
      (p) => p.applicationSubType === selectedSubcategory
    );
    setFilteredProducts(filtered);
  };

  const viewProduct = (id) => {
    navigate(`/product/${id}`);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Figtree:wght@300;400;500;600;700;800;900&display=swap');
        .hlc-shop{font-family:Figtree,system-ui;background:#fafafa;padding:40px 16px}
        .hlc-shop__intro{text-align:center;margin-bottom:40px}
        .hlc-shop__intro h1{font-size:36px;font-weight:600;color:#35335b}
        .hlc-shop__intro p{font-size:16px;color:#555;margin-top:6px}
        .hlc-shop__layout{max-width:1200px;margin:0 auto;display:grid;grid-template-columns:260px 1fr;gap:24px}
        .hlc-shop__filters{background:#fff;border:1px solid #eee;padding:18px;position:sticky;top:90px}
        .hlc-shop__filters label{font-size:12px;font-weight:700;margin-top:10px;display:block}
        .hlc-shop__filters select{width:100%;padding:8px;border:1px solid #ddd}
        .filter-actions{display:flex;gap:10px;margin-top:14px}
        .filter-actions button{flex:1;padding:10px;font-weight:700;font-size:13px;border:1px solid #9b1f6c;border-radius:0;cursor:pointer}
        #applyFilters{background:#9b1f6c;color:#fff}
        #applyFilters:hover{filter:brightness(1.1)}
        #clearFilters{background:#fff;color:#9b1f6c}
        #clearFilters:hover{background:#fff0f8}
        .product-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:22px}
        .product-card{background:#fff;border:1px solid #eee;transition:.25s;cursor:pointer}
        .product-card:hover{transform:translateY(-4px);box-shadow:0 14px 30px rgba(0,0,0,.08)}
        .product-card img{width:100%;height:240px;object-fit:contain;background:#f5f5f5}
        .product-info{padding:14px}
        .price{font-weight:800}
        .actions{display:flex;gap:8px;margin-top:8px}
        .actions button{flex:1;padding:10px;font-weight:700;font-size:13px;border-radius:0;cursor:pointer;border:1px solid #9b1f6c;background:#fff;color:#9b1f6c}
        .actions button:hover{background:#fff0f8}
        .actions button:last-child{background:#9b1f6c;color:#fff}
        .actions button:last-child:hover{filter:brightness(1.1)}
        @media(max-width:768px){.hlc-shop__layout{grid-template-columns:1fr}.product-grid{grid-template-columns:1fr}}
      `}</style>

      <Navbar />
      <div style={{ marginTop: '85px' }} />

      <section className="hlc-shop__intro">
        <h1>{selectedSubcategory || "Products"}</h1>
        <p>{subcategoryDescription || "Explore products of this subcategory"}</p>
      </section>

      <div className="hlc-shop__layout">
        <aside className="hlc-shop__filters">
          <h3>Filters</h3>

          <label>Main Category</label>
          <select value={filters.main} onChange={(e) => handleFilterChange('main', e.target.value)}>
            <option value="">All</option>
            {categories.map(cat => (
              <option key={cat.id} value={cat.name}>{cat.name}</option>
            ))}
          </select>

          <label>Application</label>
          <select value={filters.app} onChange={(e) => handleFilterChange('app', e.target.value)}>
            <option value="">All</option>
            {Object.keys(applicationSubTypes).map(app => (
              <option key={app} value={app}>{app}</option>
            ))}
          </select>

          <label>Wattage</label>
          <select value={filters.watt} onChange={(e) => handleFilterChange('watt', e.target.value)}>
            <option value="">Any</option>
            <option>5-9</option>
            <option>10-18</option>
            <option>20-30</option>
            <option>50+</option>
          </select>

          <div className="filter-actions">
            <button type="button" id="applyFilters" onClick={applyFilters}>Apply Filters</button>
            <button type="button" id="clearFilters" onClick={clearFilters}>Clear</button>
          </div>
        </aside>

        <main>
          <div className="product-grid">
            {filteredProducts.length === 0 && <p style={{ textAlign: "center" }}>No products available</p>}

            {filteredProducts.map(product => (
              <div key={product.id} className="product-card" onClick={() => viewProduct(product.id)}>
            <ProductImage product={product} />

                <div className="product-info">
                  <h4>{product.name}</h4>
                        <div className="price">
  {typeof product.price === "number" ? `PKR : ${product.price.toLocaleString()}` : product.price}
</div>

<div>
  <strong>WATT COLOUR MODEL:</strong>{" "}
  {product.wattColourModel?.join(", ")}
</div>

{/* Pin Type */}
{product.pinType?.length > 0 && (
  <div>
    <strong>PIN TYPE:</strong> {product.pinType.join(", ")}
  </div>
)}

{/* Size */}
{product.size?.length > 0 && (
  <div>
    <strong>SIZE:</strong> {product.size.join(", ")}
  </div>
)}

{/* Colour */}
<div>
  <strong>COLOUR / TYPE:</strong> {product.colourType?.join(", ")}
</div>
                  <div>Application: {product.applicationType}</div>
                  <div className="actions">
                    <button>View</button>
                    <button>Add to Cart</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </main>
      </div>

      <HlcFooter />
    </>
  );
}
